import React from "react";
import VerifyTokenCard from "./components/VerifyTokenCard";

function VerifyTokenMain() {
  return (
    <section className="auth-main-page d-flex align-items-center justify-content-center">
      <VerifyTokenCard />
    </section>
  );
}

export default VerifyTokenMain;
